export default __webpack_public_path__ + "static/amazon-a8a3f55484b0e7d30c3ab0ae416cc69d.svg";